'use client';

import Image from 'next/image';
import { useTranslation } from '@/hooks/useTranslations';
import './PlatformSection.scss';

export default function PlatformSection() {
  const { t } = useTranslation();

  return (
    <section
      id="how-it-works"
      className="platform-section"
      aria-labelledby="platform-section-title"
    >
      <div className="platform-section__inner">
        <p className="platform-section__label">{t('platform.label')}</p>

        <h2 id="platform-section-title" className="platform-section__title">
          {t('platform.titleLine1')}
          <br />
          {t('platform.titleLine2')}
        </h2>

        <p className="platform-section__subtitle">
          {t('platform.subtitleLine1')}
          <br />
          {t('platform.subtitleLine2')}
        </p>

        <ul className="platform-section__tabs">
          <li className="platform-section__tab">
            <Image
              src="/applications-icon.svg"
              alt={t('platform.tabs.applications.iconAlt')}
              width={20}
              height={20}
              className="platform-section__tab-icon"
            />
            <span>{t('platform.tabs.applications.label')}</span>
          </li>
          <li className="platform-section__tab">
            <Image
              src="/team-icon.svg"
              alt={t('platform.tabs.team.iconAlt')}
              width={20}
              height={20}
              className="platform-section__tab-icon"
            />
            <span>{t('platform.tabs.team.label')}</span>
          </li>
          <li className="platform-section__tab">
            <Image
              src="/contracts-icon.svg"
              alt={t('platform.tabs.contracts.iconAlt')}
              width={20}
              height={20}
              className="platform-section__tab-icon"
            />
            <span>{t('platform.tabs.contracts.label')}</span>
          </li>
          <li className="platform-section__tab">
            <Image
              src="/compliance-icon.svg"
              alt={t('platform.tabs.compliance.iconAlt')}
              width={20}
              height={20}
              className="platform-section__tab-icon"
            />
            <span>{t('platform.tabs.compliance.label')}</span>
          </li>
          <li className="platform-section__tab">
            <Image
              src="/communications-icon.svg"
              alt={t('platform.tabs.communications.iconAlt')}
              width={20}
              height={20}
              className="platform-section__tab-icon"
            />
            <span>{t('platform.tabs.communications.label')}</span>
          </li>
        </ul>

        <Image
          src="/platform-img.svg"
          alt={t('platform.imageAlt')}
          width={780}
          height={566}
          className="platform-section__image"
        />

        <div className="platform-section__cards">
          <Image
            src="/applications-img.png"
            alt={t('platform.cards.applications.alt')}
            width={414}
            height={512}
            className="platform-section__card-image"
          />
          <Image
            src="/contracts-img.png"
            alt={t('platform.cards.contracts.alt')}
            width={414}
            height={512}
            className="platform-section__card-image"
          />
          <Image
            src="/team-img.png"
            alt={t('platform.cards.team.alt')}
            width={414}
            height={512}
            className="platform-section__card-image"
          />
        </div>
      </div>
    </section>
  );
}
